import React from 'react'
import { Spinner } from 'react-bootstrap'

const LoadingAnimation = (props: { text: string }) => {
  const { text } = props
  return (
    <div
      className='d-flex flex-column align-items-center position-absolute mt-3'
      style={{
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <Spinner animation='border' variant='primary' />
      <h4>{text}</h4>
    </div>
  )
}

export default LoadingAnimation
